/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resources_TitleInputs */

const en_directory_agents_resources_title = /** @type {(inputs: Directory_Agents_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents & endpoints`)
};

const zh_directory_agents_resources_title = /** @type {(inputs: Directory_Agents_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档与端点`)
};

/**
* | output |
* | --- |
* | "Documents & endpoints" |
*
* @param {Directory_Agents_Resources_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resources_title = /** @type {((inputs?: Directory_Agents_Resources_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resources_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resources_title(inputs)
	return zh_directory_agents_resources_title(inputs)
});
export { directory_agents_resources_title as "directory.agents.resources_title" }